import { insertOrUpdateBlock } from "@blocknote/core";
import type { DefaultReactSuggestionItem } from "@blocknote/react";
import type { BnEditor } from "blocks-schema";
import { Icon, iconStyles } from "ui";

export function insertTwoImagesBlockItems(editor: BnEditor): DefaultReactSuggestionItem[] {
  return [
    {
      title: "Two Images",
      onItemClick: () => {
        editor.transact(() => {
          const block = insertOrUpdateBlock(editor, {
            type: "twoImagesBlock",
            props: {
              leftImage: "",
              rightImage: "",
              leftAlt: "",
              rightAlt: "",
              leftUrl: "",
              rightUrl: "",
              leftCaption: "",
              rightCaption: "",
              widthPercentage: 50,
            },
          });
          editor.setTextCursorPosition(block);
        });
      },
      aliases: ["two images", "side by side", "image pair", "dual images"],
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="ColumnsImageAndImage" />,
      subtext: "Add two images side by side",
    },
  ];
}
